import { NgClass } from '@angular/common';
import {
    Component,
    Inject,
    ElementRef,
    OnInit,
    AfterViewInit,
    Renderer2,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    inject,
    DOCUMENT
} from '@angular/core';
import { ConfigService } from '@config';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { InConfiguration, DirectionService, RightSidebarService } from '@core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgScrollbar } from 'ngx-scrollbar';
import { FeatherIconsComponent } from '@shared/components/feather-icons/feather-icons.component';
import { ThemeService } from '@core/service/theme.service';
import { CustomConfiguration } from '@core/models/custom-configuration.interface';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-right-sidebar',
    templateUrl: './right-sidebar.component.html',
    styleUrls: ['./right-sidebar.component.scss'],
    imports: [
        NgClass,
        FeatherIconsComponent,
        NgScrollbar,
        MatButtonToggleModule,
        MatSlideToggleModule,
        TranslatePipe,
    ],
    providers: [RightSidebarService]
})
export class RightSidebarComponent extends UnsubscribeOnDestroyAdapter implements OnInit, AfterViewInit {
    selectedBgColor = 'white';
    maxHeight?: string;
    maxWidth?: string;
    showpanel = false;
    isOpenSidebar?: boolean;
    isDarkSidebar = false;
    isDarTheme = false;
    public innerHeight?: number;
    headerHeight = 60;
    isRtl = false;
    public config!: InConfiguration & CustomConfiguration;
    private themeService = inject(ThemeService);

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        public elementRef: ElementRef,
        private rightSidebarService: RightSidebarService,
        private configService: ConfigService,
        private directionService: DirectionService,
        private ref: ChangeDetectorRef, // !!!
    ) {
        super();
    }

    ngOnInit() {
        this.config = this.configService.configData;
        this.subs.sink = this.rightSidebarService.sidebarState.subscribe({
            next: (isRunning) => {
                this.isOpenSidebar = isRunning;
                this.ref.markForCheck(); // !!!
            }
        });

        this.setRightSidebarWindowHeight();

        this.themeService.loadThemeSettings();
        this.subs.sink = this.themeService.themeSettings$.subscribe({
            next: (settings) => {
                this.isDarTheme = settings.isDarkTheme;
                this.isDarkSidebar = settings.isDarkSidebar;
                this.selectedBgColor = settings.selectedBgColor;
                this.isRtl = settings.isRtl;
                this.ref.markForCheck();
            }
        });
    }

    ngAfterViewInit() {
        this.selectedBgColor = localStorage.getItem('choose_skin_active') as string;

        if (localStorage.getItem('menuOption')) {
            if (localStorage.getItem('menuOption') === 'menu_dark') {
                this.isDarkSidebar = true;
            } else if (localStorage.getItem('menuOption') === 'menu_light') {
                this.isDarkSidebar = false;
            }
        }

        if (localStorage.getItem('theme')) {
            if (localStorage.getItem('theme') === 'dark') {
                this.isDarTheme = true;
            } else if (localStorage.getItem('theme') === 'light') {
                this.isDarTheme = false;
            }
        }

        if (localStorage.getItem('isRtl')) {
            if (localStorage.getItem('isRtl') === 'true') {
                this.isRtl = true;
            } else if (localStorage.getItem('isRtl') === 'false') {
                this.isRtl = false;
            }
        }
    }

    // selectTheme(e: string) {
    //     this.selectedBgColor = e;
    //     const prevTheme = this.elementRef.nativeElement.querySelector('.settingSidebar .choose-theme li.active').getAttribute('data-theme');
    //     this.renderer.removeClass(this.document.body, 'theme-' + prevTheme);
    //     this.renderer.addClass(this.document.body, 'theme-' + this.selectedBgColor);
    //     localStorage.setItem('choose_skin', 'theme-' + this.selectedBgColor);
    //     localStorage.setItem('choose_skin_active', this.selectedBgColor);
    // }

    selectTheme(color: string) {
        this.themeService.updateThemeSettings(
            {
                selectedBgColor: color
            },
            this.renderer
        );
    }

    // lightSidebarBtnClick() {
    //     this.renderer.removeClass(this.document.body, 'menu_dark');
    //     this.renderer.removeClass(this.document.body, 'logo-black');
    //     this.renderer.addClass(this.document.body, 'menu_light');
    //     this.renderer.addClass(this.document.body, 'logo-white');
    //     const menuOption = 'menu_light';
    //     localStorage.setItem('choose_logoheader', 'logo-white');
    //     localStorage.setItem('menuOption', menuOption);
    // }

    lightSidebarBtnClick() {
        this.themeService.updateThemeSettings({
        isDarkSidebar: false
        }, this.renderer);
    }

    // darkSidebarBtnClick() {
    //     this.renderer.removeClass(this.document.body, 'menu_light');
    //     this.renderer.removeClass(this.document.body, 'logo-white');
    //     this.renderer.addClass(this.document.body, 'menu_dark');
    //     this.renderer.addClass(this.document.body, 'logo-black');
    //     const menuOption = 'menu_dark';
    //     localStorage.setItem('choose_logoheader', 'logo-black');
    //     localStorage.setItem('menuOption', menuOption);
    // }

    darkSidebarBtnClick() {
        this.themeService.updateThemeSettings(
            {
                isDarkSidebar: true
            },
            this.renderer
        );
    }

    // lightThemeBtnClick() {
    //     this.renderer.removeClass(this.document.body, 'dark');
    //     this.renderer.removeClass(this.document.body, 'submenu-closed');
    //     this.renderer.removeClass(this.document.body, 'menu_dark');
    //     this.renderer.removeClass(this.document.body, 'logo-black');

    //     if (localStorage.getItem('choose_skin')) {
    //         this.renderer.removeClass(this.document.body, localStorage.getItem('choose_skin') as string);
    //     }
    //     else {
    //         this.renderer.removeClass(this.document.body, 'theme-' + this.config.layout.theme_color);
    //     }

    //     this.renderer.addClass(this.document.body, 'light');
    //     this.renderer.addClass(this.document.body, 'submenu-closed');
    //     this.renderer.addClass(this.document.body, 'menu_light');
    //     this.renderer.addClass(this.document.body, 'logo-white');
    //     this.renderer.addClass(this.document.body, 'theme-white');

    //     const theme = 'light';
    //     const menuOption = 'menu_light';
    //     this.selectedBgColor = 'white';
    //     this.isDarkSidebar = false;

    //     localStorage.setItem('choose_logoheader', 'logo-white');
    //     localStorage.setItem('choose_skin', 'theme-white');
    //     localStorage.setItem('theme', theme);
    //     localStorage.setItem('menuOption', menuOption);
    // }

    lightThemeBtnClick() {
        this.themeService.updateThemeSettings(
            {
                isDarkTheme: false,
                isDarkSidebar: false,
                selectedBgColor: 'white'
            },
            this.renderer
        );
    }

    // darkThemeBtnClick() {
    //     this.renderer.removeClass(this.document.body, 'light');
    //     this.renderer.removeClass(this.document.body, 'submenu-closed');
    //     this.renderer.removeClass(this.document.body, 'menu_light');
    //     this.renderer.removeClass(this.document.body, 'logo-white');

    //     if (localStorage.getItem('choose_skin')) {
    //         this.renderer.removeClass(this.document.body, localStorage.getItem('choose_skin') as string);
    //     }
    //     else {
    //         this.renderer.removeClass(this.document.body, 'theme-' + this.config.layout.theme_color);
    //     }

    //     this.renderer.addClass(this.document.body, 'dark');
    //     this.renderer.addClass(this.document.body, 'submenu-closed');
    //     this.renderer.addClass(this.document.body, 'menu_dark');
    //     this.renderer.addClass(this.document.body, 'logo-black');
    //     this.renderer.addClass(this.document.body, 'theme-black');

    //     const theme = 'dark';
    //     const menuOption = 'menu_dark';
    //     this.selectedBgColor = 'black';
    //     this.isDarkSidebar = true;

    //     localStorage.setItem('choose_logoheader', 'logo-black');
    //     localStorage.setItem('choose_skin', 'theme-black');
    //     localStorage.setItem('theme', theme);
    //     localStorage.setItem('menuOption', menuOption);
    // }

    darkThemeBtnClick() {
        this.themeService.updateThemeSettings(
            {
                isDarkTheme: true,
                isDarkSidebar: true,
                selectedBgColor: 'black'
            }, 
            this.renderer
        );
    }

    // switchDirection(event: MatSlideToggleChange) {
    //     const isrtl = String(event.checked);
    //     if (isrtl === 'false' && document.getElementsByTagName('html')[0].hasAttribute('dir')) {
    //         document.getElementsByTagName('html')[0].removeAttribute('dir');
    //         this.renderer.removeClass(this.document.body, 'rtl');
    //         this.directionService.updateDirection('ltr');
    //     }
    //     else if (isrtl === 'true' && !document.getElementsByTagName('html')[0].hasAttribute('dir')) {
    //         document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    //         this.renderer.addClass(this.document.body, 'rtl');
    //         this.directionService.updateDirection('rtl');
    //     }

    //     localStorage.setItem('isRtl', isrtl);
    //     this.isRtl = event.checked;
    // }

    switchDirection(event: MatSlideToggleChange) {
        this.themeService.updateThemeSettings(
            {
                isRtl: event.checked
            },
            this.renderer
        );
    }

    setRightSidebarWindowHeight() {
        this.innerHeight = window.innerHeight;
        const height = this.innerHeight - this.headerHeight;
        this.maxHeight = height + '';
        this.maxWidth = '500px';
    }

    onClickedOutside(event: Event) {
        const button = event.target as HTMLButtonElement;
        if (button.id !== 'settingBtn') {
            if (this.isOpenSidebar === true) {
                this.toggleRightSidebar();
            }
        }
    }

    toggleRightSidebar(): void {
        this.rightSidebarService.setRightSidebar((this.isOpenSidebar = !this.isOpenSidebar));
    }

    setRTLSettings() {
        document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
        this.renderer.addClass(this.document.body, 'rtl');
        this.isRtl = true;
        localStorage.setItem('isRtl', 'true');
    }

    setLTRSettings() {
        document.getElementsByTagName('html')[0].removeAttribute('dir');
        this.renderer.removeClass(this.document.body, 'rtl');
        this.isRtl = false;
        localStorage.setItem('isRtl', 'false');
    }
}
